import { ContactCardContent } from '@src/authentication/ContactCardContent';
import { Card } from '@src/common/components/Card';
import { Stack } from '@src/common/components/Stack';
import { theme } from '@src/common/styles/Theme';
import React from 'react';

type Props = {
  id?: string;
  extension?: string;
  name?: string;
  email?: string;
};

export const MobileContactCard: React.FC<Props> = ({
  id,
  extension,
  name,
  email,
}) => {
  return (
    <Card
      aria-label={id ? `contact-${id}-details` : 'no-agent-contact-details'}
    >
      <Stack direction="row" gap={theme.spacing[3]} padding={theme.spacing[2]}>
        <ContactCardContent
          id={id}
          extension={extension}
          name={name}
          email={email}
          mobile={true}
        />
      </Stack>
    </Card>
  );
};
